/**
 * Abstract platform api module.
 *
 * @author Igor Zaporozhets <deadbyelpy@gmail.com>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */


'use strict';


var api = null;


if ( PLATFORM === 'MAG' || NANOCORE ) {
    api = require('../platforms/mag/api');
}

if ( PLATFORM === 'SMARTTV' ) {
    api = require('../platforms/smarttv/api');
}

if ( PLATFORM === 'TIZEN' ) {
    api = require('../platforms/tizen/api');

    window.extendCorePrototype('device', {
        model: 'Tizen',
        serialNumber: '',
        vendor: 'Samsung',
        versionHardware: '',
        activeBank: '',
        imageDescription: '',
        imageVersion: '',
        imageVersionCurrent: '',
        mac: '',
        memory: ''
    });
}

if ( PLATFORM === 'BROWSER' ) {
    api = require('../platforms/browser/api');
}

if ( PLATFORM === 'WEBOS' ) {
    api = require('../platforms/webos/api');
    api.exit = function () {
        window.webOS.platformBack();
    };

    window.extendCorePrototype('device', {
        model: 'WebOSTV',
        serialNumber: '',
        vendor: 'LG',
        versionHardware: '',
        activeBank: '',
        imageDescription: '',
        imageVersion: '',
        imageVersionCurrent: '',
        mac: '',
        memory: ''
    });
}

window.top.platformApi = api;

module.exports = api;
